import React from 'react';
import { getSettings } from '../../util/getSettings';
import Counter from '../shared/counter';

const ParkingBays = ({ currentBays, onChange }) => {
  const labels = getSettings(['century', 'labels'], true);
  const options = [
    { label: 'Any', value: '0' },
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 }
  ];

  return (
    <fieldset className="parking-bays">
      <legend className="filter-title">{labels.parkingBaysLabel}</legend>
      <div className="counter-contaier">
        <Counter
          label={labels.parkingBaysLabel}
          countValue={currentBays}
          onCountChange={(count) => {
            onChange(count);
          }}
        />
      </div>
    </fieldset>
  );
};

export default ParkingBays;
